import { useEffect, useState } from "react";
import "./Loading.scss";

const Loading = ({className=""}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 99) {
          clearInterval(timer);
          return 99;
        }
        return Math.min(oldProgress + 10, 99); // Increase progress
      });
    }, 200); // Adjust time interval as needed

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={`loader-container ${className}`}>
      <svg className="circular-loader" viewBox="25 25 50 50">
        <circle
          className="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
      <div className="percentage">{`${progress}%`}</div>
      <div className="loader-text">Loading your data...</div>
    </div>
  );
};

export default Loading;
